// 高德地图
export const AMAP_KEY: string = 'e9c4e1537725c67ae982d59e02c6eca4'
export const AMAP_VERSION: string = '1.4.15'
// 售后专项活动名称
export const AS_ACTIVITY_NAME: string = '专项服务'
export const AS_ACTIVITY_TIP: string = '网点休息或预约已满时段不会显示'
// 灰度
export const GRAY_ENABLED = true // 灰度开关
export const GRAY_FLAG = 'half_reserve' // 灰度业务标识 bizKey（预约灰度）
export const GRAY_TIMEOUT_SEC = 5 // 灰度接口超时时间（前端 race 超时；弱网下适当放宽，避免误判超时掉版）
export const GRAY_SESSION_KEY = '__GRAY_SESSION_KEY__'
// 命中灰度的持久化标记（localStorage）有效期：仅用于「请求超时/失败」时兜底，避免已命中用户掉回旧版
export const GRAY_HIT_TTL_MS = 7 * 24 * 60 * 60 * 1000 // 7 天
export const GRAY_CHECK_API = 'public/v1/gray/check' // 灰度校验接口路径（服务 xp-ass-toc，与 newBaseService 拼接；换接口改这里）
// 客服热线
export const CUSTOMER_SERVICE_TEL = '4007836688'